interface Props {
  active: boolean;
  onToggle: () => void;
  disabled?: boolean;
  description: string;
  hint?: string | null;
}

function PillToggle({ on, onToggle, disabled }: { on: boolean; onToggle: () => void; disabled?: boolean }) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onToggle}
      className={`relative h-6 w-[42px] shrink-0 rounded-full transition-colors disabled:opacity-50 ${on ? 'bg-gold' : 'bg-line'}`}
    >
      <div className={`absolute top-0.5 h-5 w-5 rounded-full bg-paper transition-all ${on ? 'left-5' : 'left-0.5'}`} />
    </button>
  );
}

export function OpenToJoinersCard({ active, onToggle, disabled, description, hint }: Props) {
  const highlighted = active && !disabled;

  return (
    <div
      className={`rounded-xl border-2 p-4 transition-colors ${
        highlighted
          ? 'border-gold bg-gradient-to-br from-gold/20 to-gold/5 shadow-bt'
          : 'border-line bg-paper'
      }`}
    >
      <div className="flex items-center gap-3">
        <div
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-xl ${
            highlighted ? 'bg-navy text-gold' : 'bg-cream text-mute'
          }`}
        >
          👋
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-bold text-navy">Open to joiners</div>
          <div className="mt-0.5 text-[11px] leading-snug text-ink-soft">{description}</div>
        </div>
        <PillToggle on={highlighted} onToggle={onToggle} disabled={disabled} />
      </div>
      {hint && (
        <div className="mt-3 rounded-lg border border-gold/40 bg-paper/80 px-3 py-2 text-[10px] font-semibold leading-relaxed text-gold-deep">
          {hint}
        </div>
      )}
    </div>
  );
}
